import React, { Component } from 'react';
import {Container, Row, Col, Card, CardTitle, CardBody, CardFooter, Button, FormGroup, Input, Label} from 'reactstrap';
import { app } from '../../base'

class Profile extends Component {
  constructor() {
    super();
    let uid = sessionStorage.getItem("uid");
    let user_type = sessionStorage.getItem("user_type");
    this.state = {
      uid: uid,
      user_type: user_type
    };
  }

  componentDidMount() {
    /*app.database().ref('users').on('child_added', (snapshot) => {
      let info = snapshot.val(), city, province, neighborhood, street, dbObj = {};
      console.log(info);
      if (info.city) {
        dbObj.city = info.city.toUpperCase();
      }
      if (info.province) {
        dbObj.province = info.province.toUpperCase();
      }
      if (info.neighborhood) {
        dbObj.neighborhood = info.neighborhood.toUpperCase();
      }
      if (info.street) {
        dbObj.street = info.street.toUpperCase();
      }
      snapshot.ref.update(dbObj);
    });*/
    /*let dbArr = [];
    app.database().ref('categories').once('value', (snapshot)=>{
      snapshot.forEach((item)=>{
        dbArr[item.key] = item.val().image;
      });
    })
    .then(()=>{
      app.database().ref('products').on('child_added', (snapshot)=>{
        snapshot.ref.update({
          category_image: dbArr[snapshot.val().category_id]
        });
      });
    });*/
    /*let dbArr = [];
    app.database().ref('brands').once('value', (snapshot)=>{
      snapshot.forEach((item)=>{
        dbArr[item.key] = item.val().image;
      });
    })
    .then(()=>{
      app.database().ref('products').on('child_added', (snapshot)=>{
        snapshot.ref.update({
          brand_image: dbArr[snapshot.val().brand_id]
        });
      });
    });*/
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Row>
                  <Col sm="5">
                    <CardTitle className="mb-0">System tools. You are not authorized here.</CardTitle>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default Profile;


// WEBPACK FOOTER //
// ./src/views/Users/UpdateDB.js